import { RequestHelper } from 'utils';
import { API_ROUTES } from 'utils/constants';

const getLegalStatusByCountryId = (countryId) => RequestHelper.GET(API_ROUTES.LEGAL_STATUS.COUNTRY(countryId));

export const LegalStatusService = {
  getLegalStatusByCountryId
};
